import { render } from "./HeaderAdmin.vue?vue&type=template&id=1060e5b4&scoped=true"
import script from "./HeaderAdmin.vue?vue&type=script&lang=js"
export * from "./HeaderAdmin.vue?vue&type=script&lang=js"

import "./HeaderAdmin.vue?vue&type=style&index=0&id=1060e5b4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1060e5b4"]])

export default __exports__